<template>
  <today-sessions-page></today-sessions-page>
</template>

<script>
import TodaySessionsPage from '../components/today-sessions-page/index.vue';

export default { components: { TodaySessionsPage } };

</script>
